<template>
  <div
    v-if="loaded"
    :class="heroClass"
    :style="{ backgroundImage: 'url(' + backgroundImage.src + ')' }"
  >
    <div class="c-image-h1-hero__flex l-flex u-100-height">
      <div class="c-image-h1-hero__content l-flex l-flex--column">
        <h1
          v-if="title"
          :class="titleClass"
        >
          {{ title }}
        </h1>
        <img
          v-if="image"
          :src="image.src"
          :alt="image.alt || title"
          class="c-image-h1-hero__image u-margin-bottom-small"
          :class="[hideImageDesktop ? 'u-hidden-desktop' : '']"
        >
        <p
          v-if="subtitle"
          class="c-image-h1-hero__subtitle t-paragraph-large u-margin-bottom-medium"
        >
          {{ subtitle }}
        </p>
        <wysiwyg
          v-if="description"
          :html="description"
        />
        <!--        <h1 class="c-image-h1-hero__image-container">-->
        <!--          <img-->
        <!--            v-if="image"-->
        <!--            :src="image.src"-->
        <!--            :alt="image.alt"-->
        <!--            class="c-image-h1-hero__image"-->
        <!--          >-->
        <!--        </h1>-->
        <btn
          v-if="cta"
          class="c-image-h1-hero__cta"
          v-bind="cta"
        >
          {{ cta.text }}
        </btn>
      </div>
    </div>
  </div>
  <div v-else>
    <loader />
  </div>
</template>

<script>
import Btn from "../button/Btn";
import Loader from "../loader/Loader";
import Wysiwyg from "../wysiwyg/Wysiwyg";

export default {
  name: "Hero",
  components: {
    Btn,
    Loader,
    Wysiwyg
  },
  props: {
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    cta: {
      type: Object,
      default: null
    },
    desktopBackgroundImage: {
      type: Object,
      default: () => ({
        src: '',
        alt: 'desktopBackgroundImage'
      })
    },
    mobileBackgroundImage: {
      type: Object,
      default: () => ({
        src: '',
        alt: 'mobileBackgroundImage'
      })
    },
    image: {
      type: Object,
      default: null
    },
    hideImageDesktop: {
      type: Boolean,
      default: false
    },
    lifestyleAlignment: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      backgroundImage: null
    }
  },
  computed: {
    titleClass() {
      if (this.subtitle || this.cta || this.image) {
        return 'c-image-h1-hero__title t-heading-5 u-margin-bottom-small'
      } else {
        return 'c-image-h1-hero__title t-heading-5'
      }
    },
    loaded() {
      let result = true
      // for (let key of Object.keys(this.$props)) {
      //   if (
      //     this.$props[key] &&
      //     (this.$props[key]['default'] !== null)
      //   ) {
      //     result = true
      //     break
      //   }
      // }
      return result
    },
    heroClass() {
      let results = 'c-image-h1-hero'
      if (this.lifestyleAlignment != "center" && this.lifestyleAlignment != null) {
        results += " c-image-h1-hero--lifestyle-" + this.lifestyleAlignment;
      }
      if (this.desktopBackgroundImage && !this.title && !this.subtitle && !this.description && !this.cta) {
        results += ' c-image-h1-hero--just-background-image'
      }
      return results;
    }
  },
  created() {
    try {
      window.addEventListener("resize", this.updateBackgroundImage);
    } catch (err) {
      // console.log('window not loaded');
    }
  },
  mounted() {
    this.updateBackgroundImage();
  },
  destroyed() {
    try {
      window.removeEventListener("resize", this.updateBackgroundImage);
    } catch (err) {
      // console.log('window not loaded');
    }
  },
  methods: {
    updateBackgroundImage() {
      if(window.innerWidth <= 1200) {
        if (this.mobileBackgroundImage) {
          this.backgroundImage = this.mobileBackgroundImage;
        } else {
          this.backgroundImage = this.desktopBackgroundImage;
        }
      } else {
        if (this.desktopBackgroundImage)
          this.backgroundImage = this.desktopBackgroundImage;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .c-image-h1-hero {
    height: rem(600px);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
    padding-top: rem(25px);
    padding-bottom: rem(30px);
    @include themify($themes) {
      color: themed('foreground', 'white-text');
    }
    @include respond(tab-land) {
      height: rem(755px);
      background-position: top;
    }

    &--just-background-image {
      @include respond(tab-land) {
        height: 400px;
      }
    }

    &__title {
      max-width: 300px;
      text-align: left;
      @include respond(tab-land) {
        text-align: center;
      }
      /*margin: auto;*/
    }
    &__subtitle {
      max-width: 273px;
      text-align: left;
      @include respond(tab-land) {
        text-align: center;
      }
      /*margin: auto;*/
    }
    &__image {
      max-width: 100%;
      width: 350px;
      margin: auto;
      @include respond(tab-land) {
        display: inline-block;
      }
    }

    &__content {
      width: 382px;
      @include respond(tab-land) {
        text-align: center;
        align-items: center;
      }
    }

    //variant Lifestyle left overrides
    &--lifestyle-left.c-image-h1-hero {
      text-align: left;
      background-position: right;
      @media only screen and (max-width: 1300px) {
        background-position-x: -450px;
      }
      @include respond(tab-land) {
        background-position: center;
        height: auto;
      }


      .c-image-h1-hero {
        &__flex {
          justify-content: flex-end;
          @include respond(tab-land) {
            justify-content: center;
          }
        }

        &__image-container {
          width: 100%;
        }

        &__content {
          text-align: center;
          width: 620px;
          align-items: flex-start;
          @include respond(tab-land) {
            align-items: center;
            width: 250px;
          }
        }
        &__cta {
          margin: auto;
        }
      }
    }

    //variant Lifestyle right overrides
    &--lifestyle-right {
      text-align: left;
      @include respond(tab-land) {
        @include themify($themes) {
          color: themed('foreground');
        }
        padding-top: 400px;
        background-size: auto;
        text-align: center;
      }

      .c-image-h1-hero {
        &__flex {
          justify-content: flex-start;
          @include respond(tab-land) {
            justify-content: center;
          }
        }

        &__content {
          align-items: flex-start;
          @include respond(tab-land) {
            align-items: center;
          }
        }
      }
    }
  }
</style>
